import React, { useState, useEffect, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
// import moment from 'moment';
import { InputItem, ActionSheet, Popover, Button, Tabs } from 'antd-mobile'
import CustomerList from '../components/CustomerList'
import { GetCustomerList } from "../../../api/usms";
// import { GetSelfPermissions } from "../../../api/acl";
import { AclKeys } from '../utils/permissions';
import CustomerInfoList from './CustomerInfoList';
import Permission from '../components/Permission';

import { getSmsType, setSmsType } from '../../localStorage';

const Item = Popover.Item;

const tabs = [
  { title: '用户列表' },
  { title: '新增用户' },
];

function List(props) {
  const smsType = getSmsType();

  const [selectProductVisible, setSelectProductVisible] = useState(false);

  const [emailInput, setEmailInput] = useState("")
  const [companyInput, setCompanyInput] = useState("")

  const [tabPage, setTabPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [companyList, setCompanyList] = useState([])
  const [allCompanyList, setAllCompanyList] = useState([])

  const { history } = props;

  const onSearch = useCallback((val) => {
    searchList({
      CompanyId: companyInput,
      CompanyEmail: emailInput,
      ...val
    });

    if (val.CompanyId !== undefined) {
      setCompanyInput(val.CompanyId);
    }
    if (val.CompanyEmail !== undefined) {
      setEmailInput(val.CompanyEmail);
    }
  }, [allCompanyList, companyInput, emailInput])

  const getList = useCallback((data) => {
    const params = {
      ...data
    }
    setLoading(true);
    GetCustomerList(params).then(res => {
      const { Data } = res;
      if (Data && Data.List) {
        setAllCompanyList(Data.List);
        setCompanyList(Data.List);
      } else {
        setErrorMessage("获取用户信息失败")
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }, []);

  const handleAction = (value) => {
    const BUTTONS = ['实时扣费配置', '取消'];
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      message: `当前操作用户 ${value.CompanyEmail}`,
      maskClosable: true,
      'data-seed': 'logId',
    },
      (buttonIndex) => {
        if (buttonIndex === BUTTONS.length - 1) {
          return
        } else {
          handleSelectAction(buttonIndex, value)
        }
      });
  }

  const handleSelectAction = (index, value) => {
    switch (index) {
      case 0: history.push(`/usms/customerdetail?type=discount&id=${value.CompanyId}`); break;
      default: ; break;
    }
  }

  const searchList = useCallback(({
    CompanyId,
    CompanyEmail,
  }) => {
    // 前端模糊筛选逻辑，指定筛选字段CompanyId, CompanyEmail
    const list = JSON.parse(JSON.stringify(allCompanyList))
    const search = list.filter(item => {
      const email = item.CompanyEmail || "";
      const id = String(item.CompanyId) || "";

      let result = true;

      if (CompanyEmail) {
        result = result && email.indexOf(CompanyEmail) > -1;
      }
      if (CompanyId) {
        result = result && id.indexOf(CompanyId) > -1;
      }

      return result;
    })
    setCompanyList(search)
  }, [allCompanyList]);

  useEffect(() => {
    getList()
  }, []);

  return <div className="container">
    <Permission aclKey={AclKeys.Customers}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
        <h3>{`${smsType === 'Text' ? 'USMS' : ''} 用户配置管理：`}</h3>
        <Popover mask
          overlayStyle={{ color: 'currentColor' }}
          visible={selectProductVisible}
          overlay={[
            (<Item key="Text" value="Text" disabled={smsType === 'Text'}>文本短信USMS</Item>),
            (<Item key="EMAIL" value="EMAIL" disabled={smsType === 'EMAIL'} style={{ whiteSpace: 'nowrap' }}>邮件 Email</Item>),
          ]}
          align={{
            overflow: { adjustY: 0, adjustX: 0 },
            offset: [-10, 0],
          }}
          onVisibleChange={visible => setSelectProductVisible(visible)}
          onSelect={value => {
            setSmsType(value.key);
          }}
        >
          <Button type="primary" size='small' style={{ fontSize: 12, width: 80 }}>切换产品</Button>
        </Popover>
      </div>
      <Tabs tabs={tabs}
        initialPage={0}
        swipeable={false}
        page={tabPage}
        // onChange={(tab, index) => { console.log('onChange', index, tab); }}
        onTabClick={(tab, index) => { setTabPage(index) }}
      >
        <div style={{ paddingTop: '8px' }}>
          <div style={{ margin: '10px 0' }}>
            <InputItem
              size="small"
              placeholder="公司ID"
              value={companyInput}
              onChange={value => onSearch({
                CompanyId: value,
              })}>公司ID</InputItem>
            <InputItem
              size="small"
              placeholder="邮箱"
              style={{ marginTop: '4px' }}
              value={emailInput}
              onChange={value => onSearch({
                CompanyEmail: value,
              })}>邮箱</InputItem>
          </div>

          <div>
            <CustomerList
              loading={loading}
              errorMessage={errorMessage}
              companyList={companyList}
              handleAction={handleAction}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
          <CustomerInfoList callback={() => {
            // setTabPage(0);
            getList();
          }} />
        </div>
      </Tabs>
    </Permission>
  </div>
}

export default withRouter(List)